import {FC, useState} from 'react'
import {Permission} from '../CustomComponents'
import {FieldProps} from '../Form'

type Props = {
  status: any
  setStatus?: (val: any) => void
  disabled?: boolean
  model?: string
  field: FieldProps
}

const StatusCell: FC<Props> = ({status, setStatus, disabled, model, field}) => {
  const [internalStatus, setInternalStatus] = useState<any>(undefined)

  const currentStatus = internalStatus !== undefined ? internalStatus : status

  if (field.type === 'select') {
    return (
      <Permission
        permission='is_edit'
        alt={<AltStatusCell status={status} field={field} />}
        model={model}
      >
        <div className='flex items-center'>
          <select
            className='form-select form-select-sm form-select-solid w-100px bg-gray-100 border-0 focus:ring-2 focus:ring-primary h-30px py-0 px-2 text-xs font-semibold rounded'
            value={currentStatus}
            onChange={(e) => {
              const val = e.target.value
              if (setStatus) {
                setStatus(val)
                setInternalStatus(val)
              }
            }}
            disabled={disabled}
          >
            {field.options?.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </Permission>
    )
  }

  return (
    <Permission
      permission='is_edit'
      alt={<AltStatusCell status={status} field={field} />}
      model={model}
    >
      <div className='flex items-center'>
        <input
          type='checkbox'
          className='w-10 h-5 rounded-full appearance-none bg-gray-300 checked:bg-[#008080] transition duration-300 relative
            before:absolute before:top-0.5 before:left-0.5 before:w-4 before:h-4 before:bg-white before:rounded-full 
            before:transition-all before:duration-300 checked:before:translate-x-5'
          checked={!!currentStatus}
          onChange={(e) => {
            if (setStatus) {
              setStatus(e.target.checked)
              setInternalStatus(e.target.checked)
            }
          }}
          disabled={disabled}
        />
      </div>
    </Permission>
  )
}

export {StatusCell}

const AltStatusCell: FC<Props> = ({status, field}) => {
  if (field.type === 'select') {
    const option = field.options?.find(o => o.value === status)
    return (
      <div className='inline-block px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 rounded border border-gray-200'>
        {option?.label || status}
      </div>
    )
  }

  return (
    <>
      {status ? (
        <div className='inline-block px-2 py-1 text-sm font-semibold text-green-800 bg-green-100 rounded'>
          {field?.truthValue || 'Enabled'}
        </div>
      ) : (
        <div className='inline-block px-2 py-1 text-sm font-semibold text-red-800 bg-red-100 rounded'>
          {field?.falseValue || 'Disabled'}
        </div>
      )}
    </>
  )
}
